/**
 * Avisos passageiros em papel — o "compra feita" que faltava (pedido do autor, 03/09).
 *
 * Qualquer action confirma um acontecimento com
 * `dispatch('avisos/avisar', { chave, parametros, icone }, { root: true })`:
 * a `chave` é de i18n (quem traduz é o FishAviso, na língua do momento), e o aviso
 * morre sozinho. É a resposta do jogo para "cliquei e... comprou?" — a confirmação
 * chega sem exigir mais um clique de "OK".
 *
 * **`texto` é a saída para o que o SERVIDOR escreveu** (09/09/2026). "Você já tem
 * 2 pedidos abertos" não tem chave de i18n: nasce pronto, em uma língua só, e é
 * justamente a frase que não pode ser trocada por um "algo deu errado" genérico.
 * Quem tem chave passa `chave`; quem tem a frase pronta passa `texto`. Nunca os
 * dois — se vierem juntos, a chave ganha, porque ela traduz.
 *
 * **`tom`** separa o que deu certo do que não deu. O bilhete nasceu só para
 * confirmar, e um "falhou" com a mesma cara de um "comprou" é o aviso que o
 * jogador aprende a ignorar.
 */
let proximoId = 1;

export default {
  namespaced: true,
  state: {
    fila: [],
  },
  mutations: {
    EMPILHAR(state, aviso) {
      state.fila.push(aviso);
    },
    REMOVER(state, id) {
      state.fila = state.fila.filter((aviso) => aviso.id !== id);
    },
  },
  actions: {
    avisar({ commit }, { chave, texto = '', parametros = {}, icone = '', tom = 'bom', duracao = 4000 }) {
      const id = proximoId++;
      commit('EMPILHAR', { id, chave, texto, parametros, icone, tom });
      // O erro fica mais tempo: é uma frase para ler, e não um "pronto" para ver.
      setTimeout(() => commit('REMOVER', id), tom === 'ruim' ? Math.max(duracao, 6000) : duracao);
    },
    dispensar({ commit }, id) {
      commit('REMOVER', id);
    },
  },
};
